import { escapeHtml } from '../format';
import { requireElement, type MountedScreen } from './dom';
import { icon } from './icons';

/** Error screen (spec §6.2-5): the parser's message as is, then "다시 고르기". */

export interface ErrorScreenOptions {
  readonly title?: string;
  readonly message: string;
  readonly help?: string | null;
  readonly retryLabel?: string;
  readonly onRetry: () => void;
  /** Optional secondary action, e.g. "샘플로 보기". */
  readonly secondary?: { readonly label: string; readonly onClick: () => void };
}

export function mountErrorScreen(stage: HTMLElement, options: ErrorScreenOptions): MountedScreen {
  const section = document.createElement('section');
  section.className = 'krc-screen krc-error';
  section.setAttribute('aria-labelledby', 'krc-error-title');
  section.innerHTML = `
    <div class="krc-card krc-error-card">
      <span class="krc-error-mark" aria-hidden="true">${icon('alert')}</span>
      <h2 class="krc-screen-title" id="krc-error-title" tabindex="-1">${escapeHtml(options.title ?? '성적표를 만들 수 없었어요')}</h2>
      <p class="krc-error-message">${escapeHtml(options.message)}</p>
      ${options.help ? `<p class="krc-error-help">${escapeHtml(options.help)}</p>` : ''}
      <button class="button button-primary" type="button" data-error-retry>${icon('upload')}<span>${escapeHtml(options.retryLabel ?? '다시 고르기')}</span></button>
      ${options.secondary ? `<button class="krc-text-button" type="button" data-error-secondary>${escapeHtml(options.secondary.label)}</button>` : ''}
    </div>`;
  stage.append(section);
  requireElement<HTMLButtonElement>(section, '[data-error-retry]').addEventListener('click', () => options.onRetry());
  section.querySelector('[data-error-secondary]')?.addEventListener('click', () => options.secondary?.onClick());
  return {
    heading: requireElement(section, '#krc-error-title'),
    dispose() {
      section.remove();
    },
  };
}
